module.exports = __webpack_public_path__ + "fonts/2dd7673.TTF";